import WorkWithMeSection from "#app/components/work-with-me.tsx";

export default function WatchCTA () {
	return <div id="watch" className="mt-8 border-t-2 border-cyan-900 pt-16">
		<WorkWithMeSection />
		<div className="section-container mb-40">
			<p className="max-w-3xl mx-auto mb-10 text-2xl">
				JaseOwns.com is the online dumping ground of Jason Ramsey and includes ramblings of an internet ⭐ star. He's a streamer, dreamer, developer, gamer, husband and father who has been a nerd owning people on the internet since dial up 🖥️☎️ 
			</p>

			<div className="button-container">
				<a href="https://youtube.com/jaseowns/live" className="p-4 px-8 rounded-full shadow-lg bg-youtube-color duration-200 hover:opacity-80">
					Watch on YouTube
				</a>
				<a href="https://twitch.tv/jaseowns" className="p-4 px-8 rounded-full shadow-lg bg-twitch-color duration-200 hover:opacity-80">
					Watch on Twitch
				</a>
			</div>

		</div>
	</div>
}